export default function getInitialState() {
  return {
    recording: null,
    isLoadingRecording: false,
    recordingOwner: undefined
  };
}
